'use strict';
window._theme = window._theme || {};


_theme.article_loaded = true;
let isLoading = false;
const stopScroll = false;
let show_blogs = 18;
const initialPosts = document.querySelectorAll('.blog-post');
initialPosts.forEach((post, index) => {
  if (index <= 18) {
    post.style.display = 'block';
  } else {
    post.style.display = 'none';
  }
});
$(document).on('scroll', function () {
  loadArticles();
});
$('body').on('click', '.load-more ', function () {
  const next = $(this).attr('next');
  const totalPages = parseInt($(this).attr('pages'));
  const currentPage = parseInt($(this).attr('current'));
  if (currentPage >= totalPages) {
    return;
  }
  _theme.article_loaded = false;
  isLoading = true;
  let url;
  const url_string = `${window.location.href}`;
  const url_current = new URL(url_string);
  const sort = url_current.searchParams.get('sort');
  const search = url_current.searchParams.get('search');
  if (sort != '' && sort != null && search != '' && search != null) {
    url = `${window.location.pathname}?sort=${sort}&page=${next}&search=${search}&sections=new-blog-all`;
  } else if (sort != '' && sort != null) {
    url = `${window.location.pathname}?sort=${sort}&page=${next}&sections=new-blog-all`;
  } else if (search != '' && search != null) {
    url = `${window.location.pathname}?search=${search}&page=${next}&sections=new-blog-all`;
  } else {
    url = `${window.location.pathname}?page=${next}&sections=new-blog-all`;
  }

  loadArticles(url, true);
  _theme.toggleLoading(1);
});

// Client-side sorting for blog posts
$('body').on('change', '#sortBy', function () {
  const sort = $(this).val();
  const container = $('.blogs-column');
  const posts = container.children('.blog-post').get();

  posts.sort(function (a, b) {
    if (sort === 'a-z') return $(a).attr('data-title').localeCompare($(b).attr('data-title'));
    if (sort === 'z-a') return $(b).attr('data-title').localeCompare($(a).attr('data-title'));
    if (sort === 'oldest')
      return parseInt($(a).attr('data-date')) - parseInt($(b).attr('data-date'));
    if (sort === 'newest')
      return parseInt($(b).attr('data-date')) - parseInt($(a).attr('data-date'));
    return 0;
  });

  $.each(posts, function (i, post) {
    container.append(post);
  });

  // Reset visibility for the first 18 posts in the new order
  show_blogs = 18;
  $('.blog-post').each(function (index) {
    if (index < show_blogs) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });

  // Update URL for UX but don't reload
  const url = new URL(window.location.href);
  url.searchParams.set('sort', sort);
  history.pushState({}, null, url.toString());
});

$('body').on('click', '.article-search-button', function () {
  const search = $(this).parent().find('input').val();
  let url;
  const url_string = `${window.location.href}`;
  const url_current = new URL(url_string);
  const page = url_current.searchParams.get('page');
  const sort = url_current.searchParams.get('sort');
  if (page != '' && page != null && sort != '' && sort != null) {
    url = `${window.location.pathname}?sort=${sort}&page=${page}&search=${search}&sections=new-blog-all`;
  } else if (page != '' && page != null) {
    url = `${window.location.pathname}?page=${page}&search=${search}&sections=new-blog-all`;
  } else if (sort != '' && sort != null) {
    url = `${window.location.pathname}?sort=${sort}&search=${search}&sections=new-blog-all`;
  } else {
    url = `${window.location.pathname}?search=${search}&sections=new-blog-all`;
  }

  loadArticles(url);
  _theme.toggleLoading(1);
});
$('.article-search input').on('keypress', function (e) {
  if (e.which === 13) {
    $('.article-search-button').click();
  }
});
$('.article-search input').on('input', function (e) {
  if ($('.article-search input').val() != '') {
    $('.search-cancel').removeClass('hidden');
  } else {
    $('.search-cancel').addClass('hidden');
  }
});
$('body').on('click', '.search-cancel', function () {
  $('.article-search input').val('');
  $('.search-cancel').addClass('hidden');
  $('.article-search-button').click();
});

function loadArticles(url, isLoadMore) {
  const allBlogPosts = document.querySelectorAll('.blog-post');
  const blog_screen_height = window.innerHeight;

  if (allBlogPosts.length > show_blogs && allBlogPosts[show_blogs]) {
    const show_last_blog = allBlogPosts[show_blogs].getBoundingClientRect().top;

    if (blog_screen_height > show_last_blog) {
      show_blogs += 18;
      allBlogPosts.forEach((post, index) => {
        if (index < show_blogs) {
          post.style.display = 'block';
        } else {
          post.style.display = 'none';
        }
      });
    }
  }

  if (url && !isLoading) {
    $.ajax({
      url: url,
      method: 'GET',
      cache: false,
      success: function (data) {
        const blogData = $(data['new-blog-all']);
        const blogs = blogData.find('.blogs-column').html();
        const more = blogData.find('#more').html();
        if (isLoadMore) {
          $('.blogs-column').append(blogs);
        } else {
          $('.blogs-column').html(blogs);
          show_blogs = 18;
        }
        $('#more').html(more);
        _theme.article_loaded = true;
        _theme.toggleLoading(0);
        isLoading = false;
      },
    });
  }
}

function removeParamFromURL(url, param) {
  const [path, searchParams] = url.split('?');
  const newSearchParams = searchParams
    ?.split('&')
    .filter((p) => !(p === param || p.startsWith(`${param}=`)))
    .join('&');
  return newSearchParams ? `${path}?${newSearchParams}` : path;
}

$('body').on('change', '#filterList', function () {
  const url = $(this).val();
  window.location.href = url;
});
